import { api } from './api';

const getAllProducts = async () => {
    const response = await api({
        url: `CustomerVouGroups/getAllProducts`,
        method: 'GET',
    });
    return response.data;
};

const getAllActiveProducts = async (params) => {
    const response = await api({
        url: `CustomerVouGroups/getActiveProducts`,
        method: 'GET',
        params,
    });
    return response.data;
};

const CustomerVouGroupsServices = {
  getAllProducts,
  getAllActiveProducts,
};

export default CustomerVouGroupsServices;
